import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description GetApps icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { GetApps } from '@sravni/design-system-icons'
 *
 * <GetApps />
 * ```
 */
var GetApps = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "GetApps", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M19.736 8.077v-6.29H9.652l8.188 8.187 1.896-1.897ZM12.116 19.787H1.736v-5.662l2.36-2.359 8.02 8.02ZM19.736 9.875v9.912h-5.833l-2.04-2.04 7.873-7.872ZM1.736 12.328V1.787h6.13l2.206 2.205-8.336 8.336ZM11.198 7.553h-.96v4.642L8.33 10.288l-.68.68 3.076 3.075.003-.003.003.003 3.076-3.076-.68-.68-1.93 1.931V7.553Z", fill: "currentColor" }))); });

export { GetApps };
//# sourceMappingURL=GetApps.js.map
